import React from "react";

interface GradientBorderPremiumTagProps {
  children: React.ReactNode;
  className?: string;
}

const GradientBorderPremiumTag: React.FC<GradientBorderPremiumTagProps> = ({ 
  children, 
  className = "" 
}) => {
  return (
    <div className={`premium-tag-wrapper relative inline-flex ${className}`}>
      <div className="premium-tag-content relative z-[1] flex items-center bg-[#DAF9F9] text-[#003E3E] px-3 py-1 rounded-full text-[10px] font-inter font-normal">
        {children}
      </div>
      
      <style>{`
        @property --animate-duration {
          syntax: '<angle>';
          initial-value: 0deg;
          inherits: false;
        }
        
        @property --Color {
          syntax: '<color>';
          initial-value: #6DD0CF;
          inherits: false;
        }
        
        @keyframes rotate {
          0% {
            --animate-duration: 0deg;
            --Color:  #6DD0CF;
          }
          25% {
            --Color: #6DD0CF;
          }
          50% {
            --animate-duration: 180deg;
            --Color: #6DD0CF;
          }
          75% {
            --Color: #6DD0CF;
          }
          100% {
            --animate-duration: 360deg;
            --Color:#6DD0CF;
          }
        }
        
        .premium-tag-wrapper:after,
        .premium-tag-wrapper:before {
          content: '';
          display: block;
          position: absolute;
          top: -1px;
          left: -1px;
          width: calc(100% + 2px);
          height: calc(100% + 2px);
          border-radius: calc(100px + 1px);
          background-size: 100% 100%;
          background-position: 0px 0px;
          background-image: conic-gradient(
            from var(--animate-duration) at 50% 50%,
            transparent 0%,
            var(--Color) 20%,
            #0DB5B5 40%,
            var(--Color) 60%,
            transparent 80%,
            transparent 100%
          );
          animation: rotate 4s infinite linear;
        }
        
        .premium-tag-wrapper:before {
          filter: blur(0.5px);
          opacity: 0.3;
        }
        
        .premium-tag-wrapper:after {
          filter: blur(0.5px);
        }
      `}</style>
    </div>
  );
};

export default GradientBorderPremiumTag;